"use client";

import React, { FC, PropsWithChildren, useEffect } from "react";
import { useSheshaApplication } from "@shesha-io/reactjs";
import { customComponentGroups } from "@/designer-components";

export const CUSTOM_COMPONENTS_PLUGIN = "PBF.CustomComponents";

/**
 * Registers this application's custom form designer components with the Shesha
 * form designer toolbox. Mount inside the ShaApplicationProvider.
 */
export const CustomComponentsPlugin: FC<PropsWithChildren> = ({ children }) => {
  const { registerFormDesignerComponents } = useSheshaApplication();

  useEffect(() => {
    registerFormDesignerComponents(CUSTOM_COMPONENTS_PLUGIN, customComponentGroups);
  }, [registerFormDesignerComponents]);

  return <>{children}</>;
};
